import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  TESTIMONIAL_EDIT,
  TESTIMONIAL_UPDATE,
  USER_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { TESTIMONIAL_UPDATED } from "../../constant/constant";
import Select from "react-select";
import { FullPageLoader } from "../../components/common/Loader";
import { Image } from "react-bootstrap";

const TestimonialEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userOptions, setUserOptions] = useState([]);

  const submit = () => {
    setLoading(true);
    setBtnDisabled(true);
    const formData = new FormData();
    formData.append("remarks", form.remarks || "");
    formData.append("to_user_id", form.to_user_id);
    if (form.images?.length) {
      Array.from(form.images).forEach((file) => {
        formData.append("images", file);
      });
    }
    axios
      .put(TESTIMONIAL_UPDATE + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(TESTIMONIAL_UPDATED);
          navigate("/testimonials");
        }
      })
      .catch((err) => {
        if (err.response?.status === 422) {
          setErrors(err.response.data.error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    axios
      .get(TESTIMONIAL_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const d = res.data.data;
          setForm({
            remarks: d.remarks || "",
            to_user_id: d.to_user_id,
            to_user_selected: d.to_user_id
              ? {
                  value: Number(d.to_user_id),
                  label: d.to_user_name || String(d.to_user_id),
                }
              : null,
            images_existing: d.images || [],
          });
        }
      })
      .finally(() => setLoading(false));

    axios
      .get(USER_LIST_DROPDOWN, {
        params: { exclude_other_region_chapter_users: 1 },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setUserOptions(res.data.data || []);
        }
      });
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Testimonials</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/testimonials"}>
                    <span>Testimonials List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit Testimonial</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/testimonials"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center"></div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="to_user_id">
                          To User<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="to_user_id"
                          options={userOptions}
                          placeholder="Select Member"
                          value={form.to_user_selected || null}
                          onChange={(selected) =>
                            setForm({
                              ...form,
                              to_user_id: selected?.value,
                              to_user_selected: selected,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="to_user_id" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="remarks">
                          Remarks<span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="remarks"
                          placeholder="Remarks"
                          rows={4}
                          value={form.remarks || ""}
                          onChange={(e) =>
                            setForm({ ...form, remarks: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="remarks" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="images">
                          Images
                        </label>
                        {form.images_existing?.length > 0 && (
                          <div className="d-flex flex-wrap mb-2 gap-2">
                            {form.images_existing.map((img, idx) => (
                              <a
                                key={idx}
                                href={img}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image
                                  src={img}
                                  width={80}
                                  height={80}
                                  className="object-fit-cover"
                                />
                              </a>
                            ))}
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          id="images"
                          name="images"
                          accept="image/*"
                          multiple
                          onChange={(e) =>
                            setForm({
                              ...form,
                              images: e.target.files,
                            })
                          }
                        />
                        <ValidationMessage error={errors} name="images" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/testimonials"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="button"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialEdit;
